import 'intersection-observer';

class ObserverTracker {
  /**
   * @constructor
   * @param {HTMLElement} element Element that will be observed
   * @param {?Object} config Configuration
   * @param {number} [config.rangeStart=50] In percent
   * @param {number} [config.rangeEnd=100] In percent
   * @param {number} [config.maxSend=1] Maximum number of firing callback
   * @param {callback} [config.onVisible] Callback fired when element visible in between rangeStart - rangeEnd
   */
  constructor(element, config = {}) {
    this.$element = element;

    this.$config = {
      isActive: false,
      visiblePercentage: 0,
      sendCount: 0,
      rangeStart: config.rangeStart || 50,
      rangeEnd: config.rangeEnd || 100,
      maxSend: config.maxSend || 1,
      onVisible: config.onVisible
    }

    this.$obsConfig = {
      root: null,
      rootMargin: '0px',
      threshold: []
    }

    this._init();
  }

  data() {
    const {
      isActive,
      visiblePercentage,
      sendCount
    } = this.$config;

    return {
      isActive,
      visiblePercentage,
      sendCount,
      time: new Date(),
    }
  }

  _sendTracker() {
    this.$config.sendCount += 1;

    const data = this.data();

    if (this.$config.onVisible) this.$config.onVisible(data);
  }

  _generateThreshold() {
    for (let i = 0; i <= 1.0; i += 0.01) {
      this.$obsConfig.threshold.push(i);
    }
  }

  _rangeValidation(percentage) {
    const { rangeStart, rangeEnd } = this.$config;

    if (percentage < rangeStart) {
      this.$config.isActive = false;
      return false;
    }

    if (percentage > rangeEnd) {
      this.$config.isActive = false;
      return false;
    }

    return true;
  }

  _changeHandle(percentage) {
    const { sendCount, maxSend, isActive } = this.$config;

    if (sendCount >= maxSend) return;

    this.$config.visiblePercentage = percentage;

    if (!this._rangeValidation(percentage)) return;

    if (!isActive) this._sendTracker();
    this.$config.isActive = true;
  }

  _setup() {
    const callback = entries => {
      entries.forEach(entry => {
        this._changeHandle(entry.intersectionRatio * 100);
      });
    };

    const io = new window.IntersectionObserver(callback, this.$obsConfig);
    io.POLL_INTERVAL = 500;
    io.observe(this.$element);
  }

  _init() {
    this._generateThreshold();
    this._setup();
  }

}

export default ObserverTracker;
